import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getBanner,
  getGruposProductos,
  requestProductosPorGrupo,
  requestProductosSearch,
} from "../../actions/producto";
import {
  postAgregarFavoritos,
  postEliminarFavoritos,
  getFavoritos,
} from "../../actions/favoritos";
import CardProduct from "./cardProduct";
import Dolar from "../../common/dolar";
import colores from "../../shared/constants/styles";
import MuiCustomInput from "./MuiCustomInput";
import CardMessage from "./CardMessage";
import LoadingCart from "../ShoppingCart/LoadingCart";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { Container, IconButton, Tooltip } from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

const Productos = (props) => {
  const { id, prod } = useParams();
  const dispatch = useDispatch();
  const [categoria, setCategoria] = useState(null);
  const [descripcion, setDescripcion] = useState("");
  const [flagForm, setFlagForm] = useState(false);
  const [grupoProducto, setGrupoProducto] = useState("");
  const [page, setPage] = useState(1);
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allItems, setAllItems] = useState(true);
  const [favoritosLocales, setFavoritosLocales] = useState(new Set());

  const localStorage = JSON.parse(window.localStorage.getItem("LocalSession"));
  const selectedClient = JSON.parse(
    window.localStorage.getItem("selectedClient"),
  );
  const esFavorito = (productoId) => favoritosLocales.has(productoId);

  const handleToggleFavorito = (e, productoId) => {
    e.stopPropagation();
    const clienteId = selectedClient?.[0]?.id ?? localStorage.clienteId;

    const request = {
      clienteId: clienteId,
      contactoid: localStorage.contactoId,
      productoId,
    };

    if (esFavorito(productoId)) {
      setFavoritosLocales((prev) => {
        const next = new Set(prev);
        next.delete(productoId);
        return next;
      });
      dispatch(postEliminarFavoritos(request));
    } else {
      setFavoritosLocales((prev) => new Set(prev).add(productoId));
      dispatch(postAgregarFavoritos(request));
    }
  };

  const { productosFavoritos } = useSelector((state) => state.favoritos);
  const listaFavoritos =
    productosFavoritos?.data?.$values ?? productosFavoritos?.data ?? [];

  useEffect(() => {
    if (listaFavoritos.length > 0) {
      setFavoritosLocales(new Set(listaFavoritos.map((f) => f.id)));
    }
  }, [listaFavoritos]);

  useEffect(() => {
    if (localStorage?.clienteId && localStorage?.contactoId) {
      dispatch(
        getFavoritos(localStorage.clienteId.trim(), localStorage.contactoId),
      );
    }
  }, []);

  // const esFavorito = (productoId) =>
  //   listaFavoritos.some((f) => f.id === productoId);

  const handleAgregarFavorito = (e, productoId) => {
    e.stopPropagation();

    const request = {
      clienteId: selectedClient?.[0]?.id ?? localStorage.clienteId,
      contactoid: localStorage.contactoId,
      productoId,
    };

    dispatch(postAgregarFavoritos(request));
  };

  useEffect(() => {
    window.localStorage.setItem("grupoId", JSON.stringify(id));
    setCategoria(id);
    dispatch(getGruposProductos(id));
    dispatch(getBanner(id));
  }, []);

  const handleChange = (value) => {
    setFlagForm(true);
    setCategoria(id);
    setGrupoProducto(value);
    setProductos([]);
    setLoading(true);
    if (selectedClient) {
      props.requestProductosPorGrupo(page, id, selectedClient[0].id, value);
    } else {
      if (
        localStorage.tipoRol === 3 ||
        localStorage.tipoRol === 5 ||
        localStorage.tipoRol === 6 ||
        localStorage.tipoRol === 7 ||
        localStorage.tipoRol === 8
      ) {
        props.requestProductosPorGrupo(page, id, localStorage.clienteId, value);
      }
    }
  };

  const handleSearch = (value) => {
    if (value && value != "") {
      setLoading(true);
      setPage(1);
      props.requestProductosSearch(categoria, value, localStorage.clienteId);
    }
  };

  useEffect(() => {
    if (descripcion.length <= 0) {
      setProductos([]);
      setLoading(true);
      if (selectedClient) {
        props.requestProductosPorGrupo(
          page,
          id,
          selectedClient[0].id,
          grupoProducto,
        );
      } else {
        if (
          localStorage.tipoRol === 3 ||
          localStorage.tipoRol === 5 ||
          localStorage.tipoRol === 6 ||
          localStorage.tipoRol === 7 ||
          localStorage.tipoRol === 8
        ) {
          props.requestProductosPorGrupo(
            page,
            id,
            localStorage.clienteId,
            grupoProducto,
          );
        }
      }
    }
  }, [descripcion]);

  const handleVerMas = () => {
    const newPage = page + 1;
    setPage(newPage);
    if (selectedClient) {
      props.requestProductosPorGrupo(
        newPage,
        id,
        selectedClient[0].id,
        grupoProducto,
      );
    } else {
      if (
        localStorage.tipoRol === 3 ||
        localStorage.tipoRol === 5 ||
        localStorage.tipoRol === 6 ||
        localStorage.tipoRol === 7 ||
        localStorage.tipoRol === 8
      ) {
        props.requestProductosPorGrupo(
          newPage,
          id,
          localStorage.clienteId,
          grupoProducto,
        );
      }
    }
  };

  useEffect(() => {
    if (props.success) {
      setLoading(false);
      if (props.productos.length > 0) {
        setAllItems(false);
        const listado_productos = productos.concat(props.productos);
        setProductos(listado_productos);
      } else {
        setAllItems(true);
      }
    }
  }, [props.productos]);

  useEffect(() => {
    if (props.success) {
      setLoading(false);
      if (props.busquedaProductos.length > 0) {
        setProductos(props.busquedaProductos);
      } else {
        setProductos([]);
      }
    }
  }, [props.busquedaProductos]);

  return (
    <div style={{ backgroundColor: colores.grisClaro }}>
      <div style={{ width: "100%" }}>
        <img src={props.banner?.trim()} style={{ width: "100%" }} alt="grupo" />
      </div>
      <Dolar></Dolar>
      {/* HEADER */}
      <div
        className="container-fluid"
        style={{
          width: "100%",
          overflow: "hidden",
          clear: "both",
          marginBottom: "1.85rem",
        }}
      >
        <div className="d-flex justify-content-center">
          <hr style={{ width: "90%", color: "black", marginTop: "0" }}></hr>
        </div>
        <Container
          maxWidth="w-100"
          style={{ paddingRight: "60px", paddingLeft: "60px" }}
        >
          <div
            className="d-flex justify-content-between flex-wrap align-items-center "
            style={{ marginBottom: "0.600rem", paddingRight: "3.5rem" }}
          >
            <h1 className="fw-bolder" style={{ fontSize: "bolder" }}>
              PRODUCTOS
            </h1>
          </div>
        </Container>
      </div>

      {/* FILTRO Y LISTADO */}
      <div
        className="container-fluid mx-0 px-0 w-100"
        style={{ margin: "2rem" }}
      >
        <div
          className="container-fluid"
          style={{
            backgroundColor: "white",
            width: "100%",
            overflow: "hidden",
            clear: "both",
            marginBottom: "1.85rem",
            paddingLeft: "76px",
            paddingRight: "76px",
          }}
        >
          <div
            className="d-flex justify-content-between"
            style={{ margin: "2rem 0", marginLeft: "3.7rem" }}
          >
            <div>
              <h2>BÚSQUEDA</h2>
            </div>
          </div>
          <div
            className="container d-flex flex-row flex-wrap"
            style={{ marginBlock: "2rem" }}
          >
            <div
              className="container-fluid d-flex flex-row mb-3 flex-wrap"
              style={{ marginLeft: "3.7rem", padding: "1rem" }}
            >
              <div className="fluid d-flex flex-start flex-wrap">
                <MuiCustomInput
                  component={"FormControl"}
                  handleChange={handleChange}
                  gruposDropdown={props.grupos}
                  productos={productos}
                  setFlagForm={setFlagForm}
                  flagForm={flagForm}
                />
                <MuiCustomInput
                  component={"TextField"}
                  onSearch={handleSearch}
                  value={descripcion}
                  setValue={setDescripcion}
                />
              </div>
            </div>

            {loading ? (
              <LoadingCart></LoadingCart>
            ) : productos.length > 0 ? (
              productos.map(
                (producto) =>
                  producto.id !== "" &&
                  (!prod || prod === producto.id) && (
                    <div key={producto.id} style={{ position: "relative" }}>
                      <CardProduct key={producto.id} data={producto} />
                      <Tooltip
                        title={
                          esFavorito(producto.id)
                            ? "Quitar de favoritos"
                            : "Agregar a favoritos"
                        }
                      >
                        <IconButton
                          onClick={(e) => handleToggleFavorito(e, producto.id)}
                          style={{
                            position: "absolute",
                            top: "12px",
                            right: "30px",
                            backgroundColor: "rgba(255,255,255,0.85)",
                            padding: "4px",
                          }}
                        >
                          {esFavorito(producto.id) ? (
                            <FavoriteIcon
                              fontSize="small"
                              style={{ color: "#c0392b" }}
                            />
                          ) : (
                            <FavoriteBorderIcon
                              fontSize="small"
                              style={{ color: "#c0392b" }}
                            />
                          )}
                        </IconButton>
                      </Tooltip>
                    </div>
                  ),
              )
            ) : localStorage.tipoRol === 3 ||
              localStorage.tipoRol === 5 ||
              localStorage.tipoRol === 6 ||
              localStorage.tipoRol === 7 ||
              localStorage.tipoRol === 8 ? (
              productos.length <= 0 ? (
                <CardMessage cliente={true}></CardMessage>
              ) : (
                <LoadingCart></LoadingCart>
              )
            ) : productos.length <= 0 ? (
              <CardMessage cliente={false}></CardMessage>
            ) : (
              <LoadingCart></LoadingCart>
            )}
          </div>
          {props.productos.length > 0 && descripcion.length <= 0 && (
            <Stack spacing={2} direction="row" justifyContent="center">
              <Button variant="outlined" onClick={handleVerMas} color="error">
                ver más...
              </Button>
            </Stack>
          )}
        </div>
      </div>
    </div>
  );
};

export default connect(
  (state) => ({
    productos: state.producto.productos,
    busquedaProductos: state.producto.busquedaProductos,
    grupos: state.producto.grupos,
    banner: state.producto.banner,
    loading: state.producto.loading,
    success: state.producto.successSearchGrupo,
  }),
  (dispatch) => ({
    requestProductosSearch: (id, search, clienteId) =>
      dispatch(requestProductosSearch(id, search, clienteId)),
    requestProductosPorGrupo: (page, id, clienteId, grupoId) =>
      dispatch(requestProductosPorGrupo(page, id, clienteId, grupoId)),
    // requestGrupos: () => dispatch(requestGrupos()),
    getGruposProductos: (id) => dispatch(getGruposProductos(id)),
    getBanner: (id) => dispatch(getBanner(id)),
  }),
)(Productos);
